import React, { createRef, useEffect, useState } from 'react';
import Carousel from 'react-elastic-carousel';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';
import { Consts, Styles } from '../../../../res';

const { carouselExamItemButton } = Styles;

const QuestionsNav = ({ questions, isViewOnly, onSelectQuestion, Q, Qindex, showNavList, isMockExam }) => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const [itemsToShow, setItemsToShow] = useState(6);
    const carouselRef = createRef();
    const carouselContainerRef = createRef();


    useEffect(() => {
        onSelectQuestion(isViewOnly ? questions[0] : questions.find(q => !q.answerText && !q.answerOptionId) || questions[questions.length - 1]);
        //eslint-disable-next-line
    }, []);

    function updateItemsToShow() {
        const containerHeight = carouselContainerRef?.current?.offsetHeight || 0;
        const itemHeight = document.getElementById("ExamNavItem")?.offsetHeight || 33;// Estimate each item's height (px)
        const newItemsToShow = Math.max(1, Math.floor(containerHeight / itemHeight));
        setItemsToShow(newItemsToShow);
    }

    if (!Q) return null;


    const selectColor = (q) => {
        // if (q.questionId === Q.questionId) return '#8CC63F';
        if (!isMockExam && q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS && q?.answerOptionId)
            return (q.isPassed || (q.answerOptionId == q?.correctAnswer?.correctAnswerOptionId)) ? "green" : "red";
        if (q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS ? q.answerOptionId : q.answerText) return '#4c4c4c';
        return '#8CC63F';
    };

    if (!showNavList) return null;
    return (
        <div className='tw-py-3 tw-h-full tw-w-full tw-m-auto tw-flex tw-flex-col tw-justify-center tw-items-center'>

            <div>
                <Button
                    icon='caret up'
                    style={{ ...carouselExamItemButton, backgroundColor: '#8CC63F' }}
                    disabled={Qindex === 0}
                    onClick={() => {
                        carouselRef.current.slidePrev();
                        onSelectQuestion(questions[Qindex - 1]);
                    }}
                />
            </div>

            <div ref={carouselContainerRef} className='tw-flex-1 tw-w-full'>
                <Carousel
                    ref={carouselRef}
                    verticalMode
                    focusOnSelect
                    isRTL={isArabic ? true : false}
                    itemsToShow={itemsToShow}
                    transitionMs={2000}
                    showArrows={false}
                    itemsToScroll={1}
                    pagination={false}
                    onResize={() => {
                        window.ExamNav = carouselRef?.current;
                        updateItemsToShow();
                    }}
                    className='tw-h-full tw-flex tw-justify-center tw-items-center'
                >
                    {questions.map((q, index) => <div id='ExamNavItem' key={index} className='tw-relative tw-p-1'>
                        {(q.answerOptionId || q.answerText) && <div className='tw-absolute tw-border-t-[12px] tw-border-t-white tw-border-e-[12px] tw-border-e-transparent tw-start-1 tw-top-1 tw-w-3 tw-h-3 tw-bg-[#bac4cb] tw-z-10' />}
                        <Button
                            content={q?.qFactIndex !== undefined ? `❔` : q?.qAterFactIndex !== undefined ? q.qAterFactIndex : index + 1}
                            icon={q.isFlagged ? 'flag' : null}
                            style={{ ...carouselExamItemButton, backgroundColor: selectColor(q), clipPath: Qindex === index ? isArabic ? 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)' : 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)' : null }}
                            onClick={() => onSelectQuestion(q)}
                        />
                    </div>)}
                </Carousel>
            </div>

            <div>
                <Button
                    icon='caret down'
                    style={{ ...carouselExamItemButton, backgroundColor: '#8CC63F' }}
                    disabled={Qindex === questions.length - 1}
                    onClick={() => {
                        carouselRef.current.slideNext();
                        onSelectQuestion(questions[Qindex + 1]);
                    }}
                />
            </div>

        </div>
    );
};


export default QuestionsNav;